// i18next-extract-mark-ns-start Services
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { slashNtoBr } from '../../../services/formatting';
import {
  mobileThresholdPixels, frames, Button, margins,
  Title, tabletThresholdPixels,
} from '../v4/styledComponents';
import withNavigation from '../../../hoc/withNavigation';
import { navigate } from '../../../services/navigation';

const Container = styled.div`
  max-width: 1180px;
  width: 100%;
  margin: 0 ${frames.desktop} ${margins.m15};
  display: flex;
  flex-direction: column;
  gap: ${margins.m5};
  @media (max-width: ${tabletThresholdPixels}) {
    margin: 0 ${frames.tablet};
    width: calc(100% - ${frames.tablet} * 2);
    gap: ${margins.m14};
  }
  @media (max-width: ${mobileThresholdPixels}) {
    margin: ${margins.m8} ${frames.mobile};
    width: calc(100% - ${frames.mobile} * 2);
    gap: ${margins.m3};
  }
`;

const BlockContainer = styled.div<{ flexDirection: boolean }>`
  display: flex;
  justify-content: space-between;
  flex-direction: ${({ flexDirection }) => (flexDirection ? 'row' : 'row-reverse')};
  align-items: center;
  max-width: 1180px;
  width: 100%;
  gap: ${margins.m5};
  @media (max-width: ${mobileThresholdPixels}) {
    display: block;
    margin: 0 auto;
  }
`;

const Img = styled.img`
  object-fit: cover;
  border-radius: 4px;
  width: 564px;
  max-height: 528px;
  @media (max-width: ${tabletThresholdPixels}) {
    width: 500px;
    height: 281px;
  }
  @media (max-width: ${mobileThresholdPixels}) {
    width: 100%;
    height: 281px;
  }
`;

const TextContainer = styled.div`
  max-width: 550px;
  @media (max-width: ${tabletThresholdPixels}) {
    max-width: 350px;
  }
  @media (max-width: ${mobileThresholdPixels}) {
    margin-top: 24px;
  }
`;

const Subtitle = styled.h2`
  font-size: 48px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0;
  @media (max-width: ${mobileThresholdPixels}) {
    font-size: 20px;
  }
`;

const Text = styled.p`
  font-size: 16px;
  @media (max-width: ${mobileThresholdPixels}) {
    font-size: 14px;
  }
`;

interface TipsServicesProps {
  articles: {
    title: string;
    text: string;
    image: string | { publicURL: string };
    link: string;
  }[];
  noTitle?: boolean;
}

function TipsServices({ articles, noTitle }: TipsServicesProps) {
  const { t } = useTranslation();
  return (
    <Container>
      {!noTitle && <Title>{t('Astuces Tillistes')}</Title> }
      {articles.map((article, index) => (
        <BlockContainer key={article.title} flexDirection={index % 2 === 0}>
          <Img
            src={typeof article.image === 'object' && 'publicURL' in article.image
              ? article.image.publicURL
              : article.image}
            alt={article.title}
          />
          <TextContainer>
            <Subtitle>{article.title}</Subtitle>
            <Text>
              {slashNtoBr(article.text)}
            </Text>
            <Button transparent onClick={() => navigate(article.link)}>{t('Lire plus')}</Button>
          </TextContainer>
        </BlockContainer>
      ))}
    </Container>
  );
}

TipsServices.defaultProps = {
  noTitle: false,
};

export default withNavigation(TipsServices);
